// src/App.jsx
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Testimonials from './pages/Testimonials'
import Contact from './pages/Contact'
import ScrollToTop from './components/ScrollToTop'
import './styles/globals.css'
import Projects from './pages/Projects'
import ScrollTopPage from './components/ScrollTopPage'

function App() {
  return (
    <Router>
      <ScrollTopPage>
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <ScrollToTop />
        </div>
      </ScrollTopPage>
    </Router>
  )
}


export default App